import { render, staticRenderFns } from "./phoneBooksDetail.vue?vue&type=template&id=48f14f10&scoped=true&"
import script from "./phoneBooksDetail.vue?vue&type=script&lang=js&"
export * from "./phoneBooksDetail.vue?vue&type=script&lang=js&"
import style0 from "./phoneBooksDetail.vue?vue&type=style&index=0&id=48f14f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f14f10",
  null
  
)

export default component.exports